import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from "moment";
import './DateTimePicker.css';

const $ = window.jQuery;

class DateTimePicker extends Component {
    static propTypes = {
        value: PropTypes.any.isRequired,
        onChange: PropTypes.func
    };
    static defaultProps = {};
    state = {};
    format = 'DD.MM.YYYY HH:mm';

    componentDidMount() {
        const {value, onChange, ...props} = this.props;

        this.$el = $(this.el);
        this.$el.daterangepicker({
            startDate: moment(value),
            endDate: moment(value),
            timePicker: true,
            timePickerIncrement: 5,
            timePicker24Hour: true,
            singleDatePicker: true,
            autoApply: true,
            locale: {
                format: this.format,
                separator: " - ",
                applyLabel: "Применить",
                cancelLabel: "Отмена",
                fromLabel: "От",
                toLabel: "До",
                customRangeLabel: "Свой",
                daysOfWeek: [
                    "Вс",
                    "Пн",
                    "Вт",
                    "Ср",
                    "Чт",
                    "Пт",
                    "Сб"
                ],
                monthNames: [
                    "Январь",
                    "Февраль",
                    "Март",
                    "Апрель",
                    "Май",
                    "Июнь",
                    "Июль",
                    "Август",
                    "Сентябрь",
                    "Октябрь",
                    "Ноябрь",
                    "Декабрь"
                ],
                firstDay: 1
            }
        }, (dateTime) => {
            if (onChange) onChange(moment(dateTime).format("YYYY-MM-DD[T]HH:mm:[00]"));
        });
    }

    componentWillUnmount() {

    }

    componentWillReceiveProps(nextProps) {
        this.$el.data('daterangepicker').setStartDate(moment(nextProps.value));
        this.$el.data('daterangepicker').setEndDate(moment(nextProps.value));
    }

    render() {
        const {value, onChange, ...props} = this.props;
        return (
            <div className="input-group date">
                <input ref={el => this.el = el} type="text" {...props} />
                    <div className="input-group-addon">
                        <i className="fa fa-calendar"/>
                    </div>
            </div>
        );
    }
}

export default DateTimePicker;


// WEBPACK FOOTER //
// ./src/controls/DateTimePicker.js